module.exports = __webpack_public_path__ + "static/media/Cody_Limber.d461bc29.png";